import { render, staticRenderFns } from "./articleDIYType.vue?vue&type=template&id=e9c5b1b8&scoped=true&"
import script from "./articleDIYType.vue?vue&type=script&lang=js&"
export * from "./articleDIYType.vue?vue&type=script&lang=js&"
import style0 from "./articleDIYType.vue?vue&type=style&index=0&id=e9c5b1b8&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9c5b1b8",
  null
  
)

component.options.__file = "articleDIYType.vue"
export default component.exports